import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Icon, Menu, MenuItem } from '@material-ui/core';
import { UserChip } from '.';
import ShoutoutImage from './ShoutoutImage';
import './Shoutout.scss';
import { deleteShoutout } from '../actions/ShoutoutsActions';
import { Modal } from './Modal';
import { PrismButton } from './PrismButton';

const MINUTE = 1000 * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;

class Shoutout extends Component {
  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

  state = { dateString: '', showDeleteModal: false, openEditShoutout: false };
  userOptions = null;

  UNSAFE_componentWillMount() {
    this.setDate();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.shoutout && nextProps.shoutout !== this.props.shoutout) {
      this.setDate();
    }
  }

  getReadableDate(d) {
    const date = new Date(d);
    let time = date.toLocaleTimeString();
    let timeSplit = time.split(":");
    time = timeSplit[0] + ":" + timeSplit[1] + " " + timeSplit[2][timeSplit[2].length - 2] + timeSplit[2][timeSplit[2].length - 1];
    return this.monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear() + " - " + time;
  }

  openComments(event) {
    if (event.target.tagName === 'A' || event.target.className === 'fullscreen-image-background' ||
      this.state.showDeleteModal || this.state.openEditShoutout) {
      event.stopPropagation();
    } else {
      this.props.commentClick(this.props.shoutout);
    }
  }

  setDate() {
    const { date } = this.props.shoutout;
    const nowMs = Date.now();
    const dateMs = new Date(date).getTime();
    const diff = nowMs - dateMs;

    let dateString = '';

    if (diff < HOUR) {
      if (diff < MINUTE) dateString = '< 1 minute ago';
      else if (diff < MINUTE * 2) dateString = '1 minute ago';
      else dateString = `${Math.floor(diff / MINUTE)} minutes ago`;
      setTimeout(this.setDate.bind(this), MINUTE);
    } else if (diff < DAY) {
      if (diff < HOUR * 2) dateString = '1 hour ago';
      else dateString = `${Math.floor(diff / HOUR)} hours ago`;
      setTimeout(this.setDate.bind(this), HOUR);
    } else if (diff < WEEK) {
      if (diff < DAY * 2) dateString = '1 day ago';
      else dateString = `${Math.floor(diff / DAY)} days ago`;
    } else if (diff < WEEK * 5) {
      if (diff < WEEK * 2) dateString = '1 week ago';
      else dateString = `${Math.floor(diff / WEEK)} weeks ago`;
    } else {
      dateString = moment(dateMs).format('MMM D, YYYY • h:mm A');
    }

    this.setState({ dateString });
  }

  handleDelete() {
    const { currentUser, shoutout } = this.props;
    if (currentUser._id === shoutout.sender._id || currentUser.role === 'super_admin' || currentUser.role === 'admin') {
      this.setState({ showDeleteModal: false });
      setTimeout(() => {
        this.props.deleteShoutout(shoutout._id);
      }, 100);
    }
  }

  renderUserOptions() {
    const { currentUser, shoutout } = this.props;
    if (currentUser._id === shoutout.sender._id || currentUser.role === 'super_admin' || currentUser.role === 'admin') {
      return (
        <div>
          <span
            ref={(ref) => this.userOptions = ref}
            className="shoutout-options"
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ openEditShoutout: true });
            }}
          >
            <Icon className="shoutout-options-icon">more_vert</Icon>
          </span>
          <Menu
            open={this.state.openEditShoutout}
            className="menu-element"
            onClose={() => this.setState({ openEditShoutout: false })}
            anchorEl={this.userOptions}
          >
            <MenuItem onClick={(e) => {
              e.stopPropagation();
              this.setState({ showDeleteModal: true, openEditShoutout: false });
            }}>
              Delete
            </MenuItem>
            {/* <MenuItem>Edit</MenuItem> */}
            {/* <MenuItem>Copy Link</MenuItem> */}
          </Menu>
        </div>
      );
    }
  }

  renderTags() {
    const { tags } = this.props.shoutout;
    const { tagHash, color } = this.props;

    if (!tags.length) return null;
    return (
      <div className="tags">
        {tags.map((tag, i) => { if (tag && tagHash[tag]) return (<span style={{ color }} key={i} className="tag">{tagHash[tag]}</span>); })}
      </div>
    );
  }

  renderRecipients() {
    const { recipients } = this.props.shoutout;
    return recipients.map((recipient, i) => (
      <span style={{ marginRight: 8 }} key={i}>
        <UserChip
          user={recipient}
          extraText={recipients.length > 0 && i < (recipients.length - 1) ? ', ' : null}
        />
      </span>
    ));
  }

  render() {
    const { color, shoutout } = this.props;
    const { message, sender } = shoutout;
    const { dateString, showDeleteModal } = this.state;
    const backgroundColor = color;
    const size = message.length > 120 ? 'small' : '';
    return (
      <div className="card-wrapper">
        <Card elevation={3} className={`cardStyle ${size}`} style={{ backgroundColor }} onClick={this.openComments.bind(this)}>
          <div className="card-body">

            {this.renderUserOptions()}

            <div className="recipients">
              <strong>TO:</strong>
              {this.renderRecipients()}
            </div>

            <div
              className="message"
              dangerouslySetInnerHTML={{ __html: message }}
            />

            <ShoutoutImage shoutout={shoutout} />

            <div className="sender">
              <strong>FROM: </strong>
              <UserChip user={sender} />
            </div>

            {this.renderTags()}
          </div>

          <div className="card-footer">
            <span className="dateSent">
              {dateString}
            </span>

            <div className="badge" >
              <Icon className="icon" style={{ color: '#faa85f' }}>chat_bubble</Icon>
              {shoutout.comments.length}
            </div>
          </div>
        </Card>

        <Modal header="Delete Shoutout" className="delete" closeModal={() => this.setState({ showDeleteModal: false })} showModal={showDeleteModal}>
          <div style={{ backgroundColor: 'white', borderBottomLeftRadius: 19, borderBottomRightRadius: 19 }}>
            <div className="delete-confirmation-text">Are you sure you want to delete this shoutout?</div>
            <div className="delete-shoutout-preview">
              <div className="recipients">
                <strong>TO:</strong>
                {this.renderRecipients()}
              </div>
              <div dangerouslySetInnerHTML={{ __html: message }}></div>
            </div>
            <div className="delete-modal-buttons">
              <PrismButton
                style={{ backgroundColor: 'white', border: '1px solid #b1b0b0', color: '#4a4a4a' }}
                onClick={() => this.setState({ showDeleteModal: false, openEditShoutout: false })}
              >
                Cancel
              </PrismButton>
              <PrismButton onClick={() => this.handleDelete()}>Yes</PrismButton>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ personalizationStore, tagsStore, usersStore }) => {
  const { darkMode } = personalizationStore;
  const { currentUser } = usersStore;
  const { tagHash } = tagsStore;
  return { darkMode, tagHash, currentUser };
};

export default connect(mapStateToProps, { deleteShoutout })(Shoutout);



// WEBPACK FOOTER //
// ./src/components/Shoutout.js